import { render } from "./DepositTable.vue?vue&type=template&id=9f5acc98&scoped=true"
import script from "./DepositTable.vue?vue&type=script&lang=js"
export * from "./DepositTable.vue?vue&type=script&lang=js"

import "./DepositTable.vue?vue&type=style&index=0&id=9f5acc98&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f5acc98"]])

export default __exports__